<template>
    <div class="row-padding-common pt18">
        <div class="comment-top pb16" v-if="isInputActive">
            <div class="title-comment">{{ $t('reviews_placeholder1') }}</div>
            <div class="img-cancel comment" @click="checkInputText()"></div>
        </div>
        <div class="btn-textarea" v-if="isInputActive == false" @click="closeInput(true)">{{ $t('reviews_placeholder2') }}</div>
        <el-input
                type="textarea"
                class="btn-textarea active"
                v-model="commentInput"
                v-if="isInputActive == true"
                @click="handleEnter"
        ></el-input>
        <div class="text-exist-caption mt4" v-if="errorMessage">
            {{ $t(errorMessage)}}
        </div>

        <button
                class="btn-common btn mt18"
                type="button"
                v-if="isInputActive == true"
                @click="handleEnter"
        >{{ $t('btn_completion') }}</button>
    </div>
</template>

<script>
import eventUtil from "@/components/event/eventUtil";
import alertMixins from "@/mixins/alertMixins";
import filterMixins from "@/mixins/filterMixins";
import listMixins from "@/mixins/listMixins";
import EventBus from "@/utils/event-bus";
import eventValidator from "@/components/event/eventValidator";
import validateMixins from "@/mixins/validateMixins";

export default {
    name: "EventCommentWriteComponent",
    mixins: [alertMixins, filterMixins, listMixins, eventUtil, eventValidator, validateMixins],
    components: {
    },
    inject: [],
    provide() {
        return {
        }
    },
    props: {
        checkInputText: {type: Function, default: () => {}},
        setInputActive: {type: Function, default: () => {}},
        isInputActive: false,
        eventKey: 0,
    },
    data() {
        return {
            isRunning: false,
            isReplyEditMode: false,
            commentInput: '',
            writeApiParamSet: {
                type : 'post',
                wr_type:'post',
            },
            writeFunc: 'createEventComment',
            parsingData: {
                commentInput : 'wr_content',
            },
            writeKeyName: 'e_idx',
            writeSuccessMessage: "success_create_comment",
        }
    },
    beforeRouterEnter() {
    },
    created() {

    },
    mounted() {

    },
    beforeUnmount() {

    },
    unmounted() {
    },
    computed: {},
    methods: {
        closeInput(value){
            this.commentInput = '';
            this.setInputActive(value);
        },
        handleEnter(event){
            event.preventDefault();
            this.createComment()
        },

        makeParams(){
            let params = JSON.parse(JSON.stringify(this.writeApiParamSet));
            let dataArr = Object.keys(this.parsingData);
            dataArr.forEach(dataKey => {
                params[this.parsingData[dataKey]] = this[dataKey];
            })
            params[this.writeKeyName] = this.eventKey
            return params;
        },
        async createComment() {
            if (this.isRunning) {
                return false;
            }
            let validateResult = await this.$refs.eventCommentForm.validate()
            let isSuccess = validateResult.valid;
            if(!isSuccess){
                return;
            }
            this.isRunning = true;
            let params = this.makeParams();
            try {
                console.log(this.writeFunc);
                this.$api.$board[this.writeFunc](params).then(res => res.Data.Result).then(res => {
                    if (!res.Info.status) {
                        EventBus.$emit('apiLoading', false);
                        this.isRunning = false;
                        this.errorAlert(this.$t('fail_create_comment'));
                        return false;
                    } else {
                        this.writeAfterFunc();
                    }
                });

            } catch (e) {
                EventBus.$emit('apiLoading', false);
                this.isRunning = false;
                console.log(e);
            }
        },

        writeAfterFunc() {
            EventBus.$emit('apiLoading', false);
            this.createAlert({
                content: this.$t(this.writeSuccessMessage),
                hide: () => {
                    this.closeInput(false);
                    EventBus.$emit('getEventComment');
                }
            });
        },


    },
    watch: {},
}
</script>

<style scoped>

</style>
